<template>
    <div class="bg" :style="{height: bodyHeight + 'px'}">
        <div class="login">
            <h1>{{title}}</h1>
            <div>
                <input type="text" placeholder="请输入姓名" v-model="name">
                <button @click="toScore">{{submit}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {cdqiExpertLogin} from "@/assets/js/api";

    export default {
        name: "JudgeLogin",
        data(){
            return{
                title:"专家评分",
                submit:"登 录",
                name:null,
                bodyHeight:"",
            }
        },
        methods:{
            toScore(){
                if(this.name==null){
                    this.$toast("请输入姓名")
                    return;
                }
                this.login(this.name)
            },
            async login(name){
                const res = await cdqiExpertLogin({name})
                if(res.data.success){
                    this.$router.push({path:"/hz/js",query:{expertId:res.data.data.expertId}})
                }else{
                    this.$toast(res.data.message)
                }
            }
        },
        mounted(){
            this.bodyHeight = document.documentElement.clientHeight
        }
    }
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/score/login-bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .login{
        width: 70%;
        button{
            display: block;
            width: 100%;
            margin-top: 20px;
            color: #FFF;
            background: #0d8059;
            border: none;
            border-radius: 12px;
            padding: 8px 0;
            font-size: 14px;
            border: none;
            outline: none;
        }
    }

    input{
        display: block;
        width: 100%;
        outline: none;
        padding: 8px 0;
        margin: 25px 0 0 0;
        border-radius: 15px;
        font-size: 14px;
        text-indent: 10px;
        border: 1px #333 solid;
    }
</style>